<div
  *ngIf="column.name === BASIS; else dataCell"
  class="basis-cell"
  [prlwTableTooltip]="null"
  [basisDetails]="basisDetails"
>
  <div>
    {{ data.shipmentBasis }}
  </div>
  <div>
    {{ data.shipmentBasisData.shipmentBasisBriefDescription }}
  </div>
</div>

<ng-template #dataCell>
  <ng-container *ngIf="instrument">
    <div
      [prlwAllTableTooltip]="instrument"
      [basisDetails]="basisDetails"
      class="data-grid"
      [class]="'trend--' + (trend || 'none')"
    >
      <div
        class="data-grid-price"
        prlwHighlightChanges
        [value]="instrument.price"
        [key]="data.shipmentBasis + instrument.instrumentCode"
        [deps]="[modifiers, destination]"
        prlwShrinkTextOnOverflow
        shrunkTextFontSize="100%"
      >
        {{ instrument.price | delimitNumber }}
      </div>
      <div
        class="data-grid-price"
        [class]="{
          'delta--negative': instrument.priceDelta < 0,
          'delta--positive': instrument.priceDelta > 0,
        }"
        prlwShrinkTextOnOverflow
        shrunkTextFontSize="100%"
      >
        {{ instrument.priceDelta | delimitNumber | signNumber }}
      </div>
      <div>{{ instrument.amount | delimitNumber }} т</div>
      <div
        [class]="{
          'delta--negative': instrument.amountDelta < 0,
          'delta--positive': instrument.amountDelta > 0,
        }"
      >
        {{ instrument.amountDelta | delimitNumber | signNumber }}
      </div>
      <div>{{ instrument.time | date: 'HH:mm' }}</div>
      <div
        class="trend-indicator trend-indicator--{{
          instrument.forecast?.trend || 'none'
        }}"
      ></div>
    </div>
  </ng-container>
</ng-template>
